import { apiClient } from '@/api/api'
import type { RecommendedBannersResponse } from '@/types/BannersTypes'
import type { ProductCustomCardItem } from '@/types/ProductType'
import type {
  PromotedListResponse,
  RecommendationsCollectionsResponse
} from '@/types/recommendations'

export type Audience = string

const DEFAULT_AUDIENCE: Audience = 'woman'

export async function getRecommendationsBanners(audience: Audience = DEFAULT_AUDIENCE) {
  return apiClient.get<RecommendedBannersResponse>('collections/recommendations', {
    params: { audience }
  })
}

export const getRecommendationsCollections = async (
  limit: number,
  audience: Audience = DEFAULT_AUDIENCE
) => {
  return apiClient.get<RecommendationsCollectionsResponse<ProductCustomCardItem>>(
    '/goods/popular',
    {
      params: {
        limit,
        audience
      }
    }
  )
}

export const getPromotedList = async (limit: number, audience: Audience = DEFAULT_AUDIENCE) => {
  return apiClient.get<PromotedListResponse>('/collections/promoted', {
    params: {
      limit,
      audience
    }
  })
}
